import { GeneralErrorMessage } from '@ts-internal/shared-lib';
import { ContentBlock } from 'braid-design-system';
import type { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { useDatadogRum } from 'src/App/providers/DatadogRumProvider/useDatadogRum';

interface Props {
  children: ReactNode;
}

const ErrorFallback = () => (
  <ContentBlock>
    <GeneralErrorMessage />
  </ContentBlock>
);

export const ErrorBoundary = ({ children }: Props) => {
  const { logError } = useDatadogRum();

  return (
    <ReactErrorBoundary
      fallback={<ErrorFallback />}
      onError={(error, errorInfo) => {
        logError(error as Error, {
          reactErrorInfo: errorInfo,
        });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};
